var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6244 0.366365C13.1129 -0.122122 13.9049 -0.122122 14.3934 0.366365C14.8819 0.854853 14.8819 1.64685 14.3934 2.13533L9.64898 6.87976L14.6339 11.8647C15.1224 12.3532 15.1224 13.1451 14.6339 13.6336C14.1454 14.1221 13.3534 14.1221 12.8649 13.6336L7.88001 8.64873L2.8951 13.6336C2.40661 14.1221 1.61462 14.1221 1.12613 13.6336C0.637644 13.1451 0.637644 12.3532 1.12613 11.8647L6.11104 6.87976L1.36662 2.13533C0.87813 1.64685 0.87813 0.854853 1.36662 0.366365C1.8551 -0.122122 2.6471 -0.122122 3.13559 0.366365L7.88001 5.11079L12.6244 0.366365Z",
    fill: "#858DAD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.03dd747c8edbff6a5a6154d9dbe1cc25.svg";
export { ForwardRef as ReactComponent };